import { FormControl } from '@angular/forms';

export function ValidateBlankSpaces(control: FormControl) {
  let characters: string = (control.value || "");
  characters = characters.trim();
  //let characters = (control.value || "").replace(/\s/g, "");

  if (!control.value)
    return null;
  
  if(characters.length == 0 && (control.touched || control.dirty))
    return { 
      blankSpaces: true 
    };
  // if (characters.length < 10) {
  //   return { blankSpaces: true };
  // }
  return null;
}
